/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { PropsWithChildren, useState } from 'react';
import { TypeProcessing } from '../types/processing-schemas.ts';
import { processesContext, ProcessesContext } from '../contexts/ProcessesContext.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export type ProcessesProviderProps = PropsWithChildren<ProcessesContext<TypeProcessing>>;

export const ProcessesProvider: React.FC<ProcessesProviderProps> = ({
  typeProcessing,
  processesEndpoint,
  children
}) => {
  const [_typeProcessing] = useState<TypeProcessing>(typeProcessing);
  const [_processEndpoints] = useState<typeof processesEndpoint>(processesEndpoint);
  const [queryClient] = useState(new QueryClient());
  return (
    <processesContext.Provider
      value={{
        typeProcessing: _typeProcessing,
        processesEndpoint: _processEndpoints
      }}
    >
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </processesContext.Provider>
  );
};
